export default __webpack_public_path__ + "static/media/hgrlogo.f2afcddf.png";